<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editPlanGroup') }}</h1>
      <div class="form-container">
        <PlanGroupForm @save="save"
                       :edit-mode="true"
                       :group-data="groupData">
        </PlanGroupForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import PlanGroupForm from '@/components/PlanGroupForm'

  export default {
    components: {
      DashboardLayout,
      PlanGroupForm
    },
    methods: {
      save(groupForm) {
        this.$store.dispatch('Docflow/updatePlanGroup', {
          documentId: this.$route.params.documentId,
          groupForm
        }).then(() => {
          this.$router.go(-1)
        })
      }
    },
    mounted() {
      this.$store.dispatch('Docflow/planGroupRelations', {
        documentId: this.$route.params.documentId,
        groupId: this.$route.params.groupId
      })
    },
    computed: {
      ...mapState('Docflow', ['planGroup']),
      groupData() {
        return this.planGroup
      },
      breadcrumbs() {
        return [
          {name: 'editPlanGroup'}
        ]
      }
    }
  }
</script>
